import {
    createContext,
    useContext
} from 'react';

const GridBaseContext = createContext({});
export const useGridBase = () => useContext(GridBaseContext);
export default GridBaseContext;